<script>
    import FilterObject from '@/components/page-file-edit/FilterObject.vue';
    import FilterItemObject from '@/components/page-file-edit/FilterItemObject.vue';


    export default {
        props: {
            file: Object,
            filter: Object,
        },
        components: {
            FilterObject: FilterObject,
            FilterItemObject: FilterItemObject,
        },
        data() {
            return {
                query: '',
            }
        },
        computed: {
            // Show an inline search only for leaf groups with many options.
            showSearch() {
                return this.filter['children_filter'] == null
                    && Array.isArray(this.filter['filter_items'])
                    && this.filter['filter_items'].length > 10;
            },
            // Filter options by name, but always keep already-selected ones visible.
            visibleItems() {
                const items = this.filter['filter_items'] || [];
                const q = this.query.trim().toLowerCase();
                if (q === '') return items;
                return items.filter((item) =>
                    String(item.name).toLowerCase().includes(q) || this.isChecked(item)
                );
            }
        },
        methods: {
            async changeInput(event) {
                this.file.updateFilter(
                    this.filter.id,
                    Number(event.target.value),
                    event.target.checked
                );
            },

            isChecked(item) {
                const value = this.file.filter[this.filter.id];
                return Array.isArray(value)
                    ? value.includes(item.id)
                    : value === item.id;
            },

            filterCount() {
                return this.filter.filter_type === "popup" ? 3 : 1;
            }
        }
    }
</script>


<template>
    <div class="filter_object">
        <div class="filter_header">
            <label>{{ filter['name'] }}:</label>
        </div>

        <input
            v-if="showSearch"
            class="filter_search"
            type="text"
            v-model="query"
            :placeholder="`Search ${filter['name']}…`"
        >

        <ul
            class="children_container"
            :style="`column-count: ${filterCount()};`"
            v-if="filter['children_filter'] == null"
        >
            <div v-if="filter['is_required'] === false && filter['is_multiple'] === false">
                <input 
                    type = "radio"
                    :id = "`${file['id']}-${filter['id']}-none`"
                    :value = "null"
                    :checked="file.filter[filter.id] === null"
                    :name = "`${file['id']}-${filter['id']}`"
                    @change = "changeInput"
                >
                <label class="ml_5" :for = "`${file['id']}-${filter['id']}-none`">None</label>
            </div>
            <FilterItemObject
                v-for="filterItemValue in visibleItems" :key="filterItemValue.id"
                :file="file"
                :filter="filter"
                :filterItem="filterItemValue"
            />
        </ul>
        <div
            class="children_container"
            v-else
        >
            <FilterObject 
                v-for="(filterChildreValue, filterChildreIndex) in filter['children_filter']" :key="filterChildreIndex"
                :filter = "filterChildreValue"
                :file = "file"
            />
        </div>
    </div>
</template>


<style scoped>
    .children_container {
        max-height: 600px;
        overflow-y: auto;
        padding-right: 10px;
    }
    .children_container::-webkit-scrollbar {
        width: 10px;
        background-color: transparent;
        border-radius: 5px;
    }
    .children_container::-webkit-scrollbar-thumb {
        background-color: var(--header-separator);
        border-radius: 5px;
    }

    .filter_search {
        box-sizing: border-box;
        width: calc(100% - 10px);
        margin: 5px;
        padding: 4px 8px;
        border: 1px solid var(--header-separator);
        border-radius: 4px;
        background-color: transparent;
        color: var(--filter-header-text);
        font-size: 0.9em;
    }

    .filter_header {
        padding: 5px;
        color: var(--filter-header-text);
        background-color: var(--filter-header);
        border-bottom: 1px solid var(--header-separator);
    }
    .filter_object { 
        border: 1px solid var(--header-separator);
    }

    ul {
        list-style-type: none;

        margin: 0px;
        margin-top: 5px;
        padding: 0px;
    }
</style>